import React, { useState, useEffect } from 'react'
import { FaCheckCircle } from "react-icons/fa";
import { FaRegEnvelope } from "react-icons/fa";
import { IoLocationSharp } from "react-icons/io5";
import { IoMdSave } from "react-icons/io";
import { IoEyeOutline } from "react-icons/io5";
import { FiEyeOff } from "react-icons/fi";
import { toast } from 'react-toastify';

function calculateDaysDifference(date1, date2) {
    if (!date1 || !date2) return 0;
    const d1 = new Date(date1);
    const d2 = new Date(date2);
    d1.setHours(12,0,0,0);
    d2.setHours(12,0,0,0);
    const diffTime = d2 - d1;
    return Math.max(0, Math.ceil(diffTime / (1000 * 60 * 60 * 24)));
}

function Profile({
  id,
  username,
  email,
  days,
  Expirydate,
  mobileNumber,
  password,
  loginDate,
  accountStatus,
  accountType,
  apiKey,
  products,
  createdAt
}) {
  const [Apikey, setApiKey] = useState('');
  const [accounttype, setaccounttype] = useState('');
  const [accountstatus, setaccountstatus] = useState('');
  const [Email, setemail] = useState('');
  const [phonenumber, setphonenumber] = useState('');
  const [Password, setPassword] = useState('');
  const [ispassword, setispassword] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [Products, setProducts] = useState([]);
  const [CreatedAt, setCreatedAt] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [totalDays, setTotalDays] = useState(0);
  const [daysRemaining, setDaysRemaining] = useState(0);
  const [feedback, setFeedback] = useState({ type: null, msg: "" });
  const token = localStorage.getItem('token');

  useEffect(() => {
    setemail(email || "");
    setphonenumber(mobileNumber || "");
    setPassword(password || "");
    setaccountstatus(accountStatus || "");
    setaccounttype(accountType || "");
    setApiKey(apiKey || "");
    setProducts(products || []);
    setCreatedAt(createdAt || "");
    setExpiryDate(Expirydate || "");
    let planTotalDays = 0;
    let planDaysLeft = 0;
    if (createdAt && Expirydate) {
      planTotalDays = calculateDaysDifference(createdAt, Expirydate);
      const todayISO = new Date().toISOString().slice(0,10);
      planDaysLeft = calculateDaysDifference(todayISO, Expirydate);
    }
    setTotalDays(planTotalDays);
    setDaysRemaining(planDaysLeft);
  }, [
    email,
    mobileNumber,
    password,
    accountType,
    accountStatus,
    apiKey,
    products,
    loginDate,
    Expirydate,
    createdAt
  ]);

  const handleUpdate = async () => {
    setFeedback({ type: null, msg: "" });
    const updatedData = {
      name: username,
      email: Email,
      Mobile: phonenumber,
      password: Password,
      status: accountstatus,
      accountType: accounttype,
      Expiry: expiryDate ? expiryDate.split('T')[0] : "",
 
      API_Key: Apikey,
      products: Products,
      created: CreatedAt
    };
    let resultMsg = "";
    let isSuccess = false;
    try {
      const response = await fetch(`https://wa-api.globebot.io/auth/client/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...(token && { 'Authorization': `Bearer ${token}` })
        },
        body: JSON.stringify(updatedData)
      });

      if (response.ok) {
        // Try toast, fallback to feedback if toast fails
        try {
          if (typeof toast?.success === "function") {
            toast.success('Settings updated successfully', { autoClose: 3000 });
          } else {
            setFeedback({ type: "success", msg: "Settings updated successfully" });
          }
        } catch (e) {
          setFeedback({ type: "success", msg: "Settings updated successfully" });
        }
        isSuccess = true;
        resultMsg = "Settings updated successfully";
      } else {
        const errorText = 'Failed to update settings';
        try {
          if (typeof toast?.error === "function") {
            toast.error(errorText, { autoClose: 3000 });
          } else {
            setFeedback({ type: "error", msg: errorText });
          }
        } catch (e) {
          setFeedback({ type: "error", msg: errorText });
        }
        resultMsg = errorText;
      }
    } catch (err) {
      const errMsg = 'Unexpected error: ' + (err.message || err);
      setFeedback({ type: "error", msg: errMsg });
      resultMsg = errMsg;
    }
    // Optionally always set feedback in case toast is silent
    if (!isSuccess && resultMsg) setFeedback({ type: "error", msg: resultMsg });
    if (isSuccess && resultMsg) setFeedback({ type: "success", msg: resultMsg });
  };

  return (
    <>
      <div className='w-[100%] px-4 sm:px-8 md:px-12 lg:px-16'>
        <div className='shadow-[rgba(0,0,0,0.05)_0px_6px_24px_0px,rgba(0,0,0,0.08)_0px_0px_0px_1px] p-2 rounded-lg w-[100%] mt-2'>
          {feedback.msg && (
            <div className="mb-4 w-full flex justify-center">
              <div
                className={
                  feedback.type === "success"
                    ? "bg-green-100 text-green-800 p-2 px-4 rounded"
                    : "bg-red-100 text-red-800 p-2 px-4 rounded"
                }
              >
                {feedback.msg}
              </div>
            </div>
          )}
          <div className='w-[100%] flex flex-col sm:flex-row'>
            <div className='w-[100%] sm:w-[50%]'>
              <div className='flex flex-col sm:flex-row justify-center items-center w-[100%] gap-4 py-6 text-center sm:text-left'>
                <img src="" alt="" className='w-[100px] h-[100px] sm:w-[140px] sm:h-[140px] rounded-[32%]  border-[4px] border-[#e6683c] p-[4px]' />
                <div>
                  <h2 className='text-[#000] text-[14px] sm:text-[16px] font-semibold flex items-center justify-center sm:justify-start gap-2'>
                    {username} <FaCheckCircle className='text-[#3fca90]' />
                  </h2>
                  <p className='text-[#858c97] text-[11px] sm:text-[12px] font-semibold flex items-center justify-center sm:justify-start gap-2'>
                    <FaRegEnvelope className='text-[#ed5050] text-[14px]' />{email}
                  </p>
                  <p className='text-[#858c97] text-[11px] sm:text-[12px] font-semibold flex items-center justify-center sm:justify-start gap-2'>
                    <IoLocationSharp className='text-[#3f7fca] text-[14px]' />{ }
                  </p>
                </div>
              </div>
            </div>
            <div className='w-[100%] sm:w-[50%] mt-4 sm:mt-0'>
              <label className='text-[#858c97] text-[12px] font-semibold'>User Name</label>
              <input type="text" value={username} className='w-[100%] rounded-lg p-2 border-[1px] border-[#858c97] outline-none text-[#454546] text-[12px] font-semibold' readOnly />
              <label className='text-[#858c97] text-[12px] font-semibold'>Account Status</label>
              <select
                className='w-[100%] rounded-lg p-2 border-[1px] border-[#858c97] outline-none text-[#454546] text-[12px] font-semibold'
                value={accountstatus}
                onChange={(e) => setaccountstatus(e.target.value)}
              >
                <option value="">Select Account Status</option>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
                <option value="Blocked">Blocked</option>
              </select>
              <label className='text-[#858c97] text-[12px] font-semibold'>API Key</label>
              <input type="text" value={Apikey} className='w-[100%] rounded-lg p-2 border-[1px] border-[#858c97] outline-none text-[#454546] text-[12px] font-semibold' />
              <div className='w-[100%] flex justify-between items-center'>
                <span className='text-[#858c97] text-[12px] font-semibold'>Days</span>
                <span className='text-[#858c97] text-[12px] font-semibold'>
                  {totalDays - daysRemaining} of {totalDays} Days
                </span>
              </div>
              <div className="w-full h-[5px] bg-gray-200 rounded-full overflow-hidden">
                <div
                  className="h-full bg-[#7367f0] transition-all duration-500"
                  style={{
                    width: totalDays && totalDays > 0
                      ? `${((totalDays - daysRemaining) / totalDays) * 100}%`
                      : "0%"
                  }}
                ></div>
              </div>
              <span className='text-[#858c97] text-[12px] font-semibold'>
                {daysRemaining} days remaining until your plan expire
              </span>
            </div>
          </div>

          <div className='w-[100%] flex flex-wrap justify-between border-y-[1px] border-[#cfcdcd] mt-2 mb-2 py-4 gap-y-3'>
            <div className='w-[100%] sm:w-[48%]'>
              <label className='text-[#858c97] text-[12px] font-semibold'>Account Type</label>
              <select
                className='w-[100%] rounded-lg p-2 border-[1px] border-[#858c97] outline-none text-[#454546] text-[12px] font-semibold'
                value={accounttype}
                onChange={(e) => setaccounttype(e.target.value)}
              >
                <option value="">Select Account Type</option>
                <option value="Reseller">Reseller</option>
                <option value="User">User</option>
                <option value="Manager">Manager</option>
                <option value="Agent">Agent</option>
              </select>
            </div>

            <div className='w-[100%] sm:w-[48%]'>
              <label className='text-[#858c97] text-[12px] font-semibold'>Mobile Number</label>
              <input
                type="number"
                value={phonenumber}
                onChange={(e) => setphonenumber(e.target.value)}
                className='w-[100%] rounded-lg p-2 border-[1px] border-[#858c97] outline-none text-[#454546] text-[12px] font-semibold'
              />
            </div>

            <div className='w-[100%] sm:w-[48%]'>
              <label className='text-[#858c97] text-[12px] font-semibold'>Account Expiry Date</label>
              <input
                type="date"
                value={expiryDate ? expiryDate.slice(0, 10) : ""}
                className='w-[100%] rounded-lg p-2 border-[1px] border-[#858c97]'
                onChange={(e) => setExpiryDate(e.target.value)}
              />
            </div>

            <div className='w-[100%] sm:w-[48%]'>
              <label className='text-[#858c97] text-[12px] font-semibold'>Password</label>
              <div className='w-[100%] text-[#576071] flex justify-between border-[#576071] border-[1px] p-2 rounded-md items-center'>
                <input
                  type={showPassword ? "text" : "password"}
                  value={Password}
                  disabled={ispassword}
                  onChange={(e) => setPassword(e.target.value)}
                  className='outline-none text-[#454546] text-[12px] font-semibold bg-[#fff0]'
                />
                {showPassword ? (
                  <IoEyeOutline onClick={() => setShowPassword(!showPassword)} className='cursor-pointer ml-2' />
                ) : (
                  <FiEyeOff onClick={() => setShowPassword(!showPassword)} className='cursor-pointer ml-2' />
                )}
              </div>
            </div>

            <div className='w-[100%] flex justify-end gap-3 items-center'>
              <button
                onClick={() => setispassword(!ispassword)}
                className={`w-[25px] h-[12px] flex items-center rounded-[50px] transition duration-300 ${!ispassword ? "bg-[#37715d]" : "bg-[#b4bbc3]"}`}
              >
                <div className={`bg-[#fff] w-[10px] h-[10px] rounded-full shadow-md transform transition ml-[1px] ${!ispassword ? "translate-x-[13px]" : ""}`}></div>
              </button>
              <span className='text-[#858c97] text-[12px] font-semibold'>Change Password?</span>
            </div>

            <div className='w-[100%] sm:w-[48%]'>
              <label className='text-[#858c97] text-[12px] font-semibold'>Last Login Date</label>
              <input type="date" value={loginDate} className='w-[100%] rounded-lg p-2 border-[1px]' readOnly />
            </div>

            <div className='w-[100%] sm:w-[48%]'>
              <label className='text-[#858c97] text-[12px] font-semibold'>Email Id</label>
              <input
                type="Email"
                value={Email}
                onChange={(e) => setemail(e.target.value)}
                className='w-[100%] rounded-lg p-2 border-[1px]'
              />
            </div>
          </div>

          <div className='w-[100%] flex justify-center sm:justify-end items-center'>
            <button
              onClick={handleUpdate}
              className='p-2 bg-[#00816a] rounded-md text-[12px] flex items-center gap-1 font-semibold text-[#fff]'>
              <IoMdSave /> Update Settings
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

export default Profile